(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    initStickyHeader();
    initAccountPlacement();
    initMobileMenu();
    initDropdownMenu();
    initShopMenue();
    initSearchDrawer();
    initQualityBar();
  });

  /* Passen nicht alle Qualitätsmerkmale in die Zeile, alle 6 s die nächsten einblenden.
     Was sichtbar ist, entscheidet weiter das CSS (Zeile 2 wird verschluckt). Marc 2026-10-20. */
  function initQualityBar() {
    const inner = document.querySelector('.quality-bar__inner');
    if (!inner || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const original = [...inner.children];
    let paused = false;
    inner.addEventListener('mouseenter', () => { paused = true; });
    inner.addEventListener('mouseleave', () => { paused = false; });

    setInterval(async () => {
      if (paused || document.hidden) return;
      const items = [...inner.children];
      const top = items[0].offsetTop;
      const shown = items.filter((item) => item.offsetTop === top);
      if (shown.length === items.length) {
        if (items[0] !== original[0]) inner.append(...original);
        return;
      }

      const fadeOut = inner.animate({ opacity: [1, 0] }, { duration: 300, fill: 'forwards' });
      await fadeOut.finished;
      inner.append(...shown);
      inner.animate({ opacity: [0, 1] }, { duration: 300 });
      fadeOut.cancel();
    }, 6000);
  }

  function initAccountPlacement() {
    const account = document.querySelector('shopify-account');
    const actions = document.querySelector('.site-header__actions');
    const nav = document.querySelector('.site-nav');
    const cart = document.getElementById('cart-toggle');
    if (!account || !actions || !nav || !cart) return;

    const mobile = window.matchMedia('(max-width: 1024px)');

    const place = () => {
      const target = mobile.matches ? nav : actions;
      if (account.parentElement === target) return;
      if (mobile.matches) nav.append(account);
      else actions.insertBefore(account, cart);
    };

    place();
    mobile.addEventListener('change', place);
  }

  function initStickyHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;

    const setHeaderHeight = () => {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    };
    setHeaderHeight();
    new ResizeObserver(setHeaderHeight).observe(header);

    const observer = new IntersectionObserver(
      ([entry]) => header.classList.toggle('is-scrolled', !entry.isIntersecting),
      { rootMargin: '-1px 0px 0px 0px', threshold: [1] }
    );

    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;pointer-events:none;';
    document.body.prepend(sentinel);
    observer.observe(sentinel);
  }

  function initDropdownMenu() {
    document.querySelectorAll('.has-dropdown').forEach(item => {
      const trigger = item.querySelector('.site-nav__link--has-dropdown');
      const panel = item.querySelector('.nav-dropdown');
      const menuItems = Array.from(item.querySelectorAll('.nav-dropdown__item'));
      if (!trigger || !panel) return;

      let closeTimer;

      /* Breakpoint-String synchron halten mit der CSS-Query und
         initAccountPlacement(). */
      const mobileMq = window.matchMedia('(max-width: 1024px)');

      /* Panel bleibt linksbuendig am Menuepunkt; nur wenn es sonst rechts
         aus dem Viewport ragen wuerde, schiebt der Inline-left es so weit
         nach links, dass die rechte Kante 16px Abstand behaelt. Messen geht
         auch am geschlossenen Panel (visibility:hidden, nicht display:none). */
      const clampPanel = () => {
        panel.style.left = '';
        if (mobileMq.matches) return;
        const viewport = document.documentElement.clientWidth;
        const overflow = panel.getBoundingClientRect().right - (viewport - 16);
        if (overflow > 0) panel.style.left = `${-overflow}px`;
      };

      const open = () => {
        clearTimeout(closeTimer);
        clampPanel();
        item.classList.add('dropdown-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
      };

      const close = () => {
        clearTimeout(closeTimer);
        item.classList.remove('dropdown-open');
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        panel.style.left = '';
      };

      const closeWithDelay = () => {
        closeTimer = setTimeout(() => {
          item.classList.remove('dropdown-open');
          trigger.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');
          panel.style.left = '';
        }, 1000);
      };

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', closeWithDelay);

      window.addEventListener('resize', () => {
        if (item.classList.contains('dropdown-open') || item.matches(':focus-within')) clampPanel();
      });

      item.addEventListener('keydown', e => {
        const currentIndex = menuItems.indexOf(document.activeElement);

        switch (e.key) {
          case 'Escape':
            if (item.classList.contains('dropdown-open')) {
              e.preventDefault();
              close();
              trigger.focus();
            }
            break;

          case 'ArrowDown':
            e.preventDefault();
            if (document.activeElement === trigger) {
              open();
              menuItems[0]?.focus();
            } else if (currentIndex >= 0) {
              menuItems[(currentIndex + 1) % menuItems.length]?.focus();
            }
            break;

          case 'ArrowUp':
            if (currentIndex >= 0) {
              e.preventDefault();
              const prev = currentIndex === 0 ? menuItems.length - 1 : currentIndex - 1;
              menuItems[prev]?.focus();
            }
            break;

          case 'Home':
            if (currentIndex >= 0) {
              e.preventDefault();
              menuItems[0]?.focus();
            }
            break;

          case 'End':
            if (currentIndex >= 0) {
              e.preventDefault();
              menuItems[menuItems.length - 1]?.focus();
            }
            break;
        }
      });

      /* Bei Tab-Fokus auf den Trigger oeffnet :focus-within das Panel rein
         per CSS, ohne open() — deshalb hier immer klemmen. */
      item.addEventListener('focusin', e => {
        clampPanel();
        if (e.target !== trigger) open();
      });

      item.addEventListener('focusout', e => {
        if (!item.contains(e.relatedTarget)) close();
      });
    });
  }

  /* Shop-Menue C2 (snippets/shop-menue.liquid). Desktop: Panel volle Breite,
     Seite dahinter abgedunkelt, Hover/Fokus auf einen Eintrag wechselt die
     Vorschau und schiebt den Marker. Handy (Breakpoint wie oben): «Shop» ist
     ein Aufklapper im Overlay-Menue. initDropdownMenu() ueberspringt diese
     Punkte, weil sie kein .nav-dropdown haben. */
  function initShopMenue() {
    const mobileMq = window.matchMedia('(max-width: 1024px)');
    const backdrop = document.querySelector('.shop-menue-hintergrund');

    document.querySelectorAll('[data-shop-menue]').forEach(item => {
      const trigger = item.querySelector('.site-nav__link--has-dropdown');
      const panel = item.querySelector('.shop-menue');
      if (!trigger || !panel) return;

      const marker = panel.querySelector('.shop-menue__marker');
      const eintraege = Array.from(panel.querySelectorAll('.shop-menue__eintrag'));
      const titel = eintraege.map(e => e.querySelector('.shop-menue__titel'));
      const vorschauen = Array.from(panel.querySelectorAll('.shop-menue__vorschau'));
      let aktiv = eintraege.find(e => e.classList.contains('is-active')) || eintraege[0];
      let closeTimer;
      let hoverSeit = 0;    // per Darüberfahren geöffnet um (0 = per Klick/Tastatur)
      let gesperrt = false; // nach dem Zuklicken öffnet die Maus erst nach Verlassen wieder

      /* Messen geht auch am geschlossenen Panel (visibility:hidden). */
      const setzeMarker = () => {
        if (!marker || !aktiv || mobileMq.matches) return;
        marker.style.top = `${aktiv.offsetTop}px`;
        marker.style.left = `${aktiv.offsetLeft}px`;
        marker.style.width = `${aktiv.offsetWidth}px`;
        marker.style.height = `${aktiv.offsetHeight}px`;
      };

      const zeige = eintrag => {
        if (!eintrag || eintrag === aktiv) return;
        aktiv.classList.remove('is-active');
        eintrag.classList.add('is-active');
        aktiv = eintrag;
        vorschauen.forEach(v => { v.hidden = v.dataset.vorschau !== eintrag.dataset.vorschau; });
        setzeMarker();
      };

      const istOffen = () => item.classList.contains('dropdown-open');

      const open = () => {
        if (mobileMq.matches) return;
        clearTimeout(closeTimer);
        item.classList.add('dropdown-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        backdrop?.classList.add('is-open');
        setzeMarker();
      };

      const close = () => {
        clearTimeout(closeTimer);
        hoverSeit = 0;
        item.classList.remove('dropdown-open');
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        backdrop?.classList.remove('is-open');
      };

      /* Desktop (Marc 2026-10-20): Darüberfahren öffnet, Klick auf «Shop»
         öffnet/schliesst. Ein per Darüberfahren geöffnetes Menü schliesst der
         Klick erst nach 1 s, sonst machte der Klick beim Ankommen es gleich zu.
         Offen bleibt es, solange die Maus im Header (mit Panel) ist; erst beim
         Verlassen schliesst es. */
      const header = item.closest('.site-header') || item;
      item.addEventListener('mouseenter', () => {
        if (mobileMq.matches || gesperrt) return;
        if (!istOffen()) hoverSeit = Date.now();
        open();
      });
      item.addEventListener('mouseleave', () => { gesperrt = false; });
      header.addEventListener('mouseenter', () => clearTimeout(closeTimer));
      const spaeterZu = () => {
        if (mobileMq.matches || !istOffen()) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(close, 300);
      };
      header.addEventListener('mouseleave', spaeterZu);
      /* Die Abdunkelung liegt auch im Header, zählt aber als «draussen». Auf
         mousemove statt mouseenter: Chromium meldet beim Erscheinen der
         Abdunkelung unter einer ruhenden Maus ein mouseenter, das ein per
         Tastatur geöffnetes Menü schliessen würde. */
      let aufHintergrund = false;
      backdrop?.addEventListener('mousemove', () => {
        if (aufHintergrund) return;
        aufHintergrund = true;
        spaeterZu();
      });
      backdrop?.addEventListener('mouseleave', e => {
        aufHintergrund = false;
        if (header.contains(e.relatedTarget)) clearTimeout(closeTimer);
      });
      /* Klick in der Leiste ausserhalb von «Shop» (Warenkorb, Suche …) schliesst,
         sonst läge der Warenkorb hinter dem offenen Menü. */
      header.addEventListener('click', e => {
        if (!mobileMq.matches && istOffen() && !item.contains(e.target)) close();
      });
      backdrop?.addEventListener('click', close);

      panel.querySelector('[data-shop-menue-zu]')?.addEventListener('click', () => {
        close();
        trigger.focus();
      });

      eintraege.forEach(e => e.addEventListener('mouseenter', () => zeige(e)));
      titel.forEach((t, i) => t?.addEventListener('focus', () => zeige(eintraege[i])));

      /* Fokus öffnet nicht mehr (Klick bzw. Enter/Leertaste/Pfeil runter).
         Schliessen nur, wenn der Fokus wirklich woanders hingeht: ein Klick auf
         eine leere Stelle im Panel gibt ihn an niemanden (Firefox) oder an die
         nav (tabindex="-1", Chromium) ab. */
      const nav = item.closest('.site-nav');
      item.addEventListener('focusout', e => {
        const ziel = e.relatedTarget;
        if (!mobileMq.matches && ziel && ziel !== nav && !item.contains(ziel)) close();
      });

      item.addEventListener('keydown', e => {
        if (mobileMq.matches) return;
        const index = titel.indexOf(document.activeElement);
        switch (e.key) {
          case 'Escape':
            if (istOffen()) {
              e.preventDefault();
              close();
              trigger.focus();
            }
            break;
          case 'ArrowDown':
            if (document.activeElement === trigger) {
              e.preventDefault();
              open();
              titel[0]?.focus();
            } else if (index >= 0) {
              e.preventDefault();
              titel[(index + 1) % titel.length]?.focus();
            }
            break;
          case 'ArrowUp':
            if (index >= 0) {
              e.preventDefault();
              titel[index === 0 ? titel.length - 1 : index - 1]?.focus();
            }
            break;
        }
      });

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && istOffen() && !item.contains(document.activeElement)) close();
      });

      /* Tipp/Klick auf «Shop» klappt auf/zu statt zu navigieren. */
      trigger.addEventListener('click', e => {
        e.preventDefault();
        if (mobileMq.matches) {
          const offen = item.classList.toggle('is-open');
          trigger.setAttribute('aria-expanded', String(offen));
          panel.setAttribute('aria-hidden', String(!offen));
          return;
        }
        if (!istOffen()) {
          open();
          return;
        }
        if (hoverSeit && Date.now() - hoverSeit < 1000) return;
        close();
        if (item.matches(':hover')) gesperrt = true;
      });

      mobileMq.addEventListener('change', () => {
        close();
        item.classList.remove('is-open');
      });

      window.addEventListener('resize', () => {
        if (istOffen()) setzeMarker();
      });

      setzeMarker();
    });
  }

  function initSearchDrawer() {
    const toggle = document.getElementById('search-toggle');
    const drawer = document.getElementById('search-drawer');
    const input = document.getElementById('search-drawer-input');
    const closeBtn = drawer?.querySelector('.search-drawer__close');
    const backdrop = document.getElementById('search-backdrop');
    const suggestions = document.getElementById('search-suggestions');
    if (!toggle || !drawer || !input) return;

    let currentFocus = -1;

    function clearSuggestions() {
      if (!suggestions) return;
      suggestions.hidden = true;
      suggestions.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      currentFocus = -1;
    }

    const open = () => {
      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Suche schliessen');
      backdrop?.classList.add('is-open');
      requestAnimationFrame(() => input.focus());
    };

    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Suche öffnen');
      backdrop?.classList.remove('is-open');
      clearSuggestions();
      toggle.focus();
    };

    toggle.addEventListener('click', () => {
      if (drawer.classList.contains('is-open')) close();
      else open();
    });

    closeBtn?.addEventListener('click', close);
    backdrop?.addEventListener('click', close);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        e.preventDefault();
        close();
      }
    });

    if (!suggestions) return;

    const form = drawer.querySelector('.search-drawer__form');
    const currencyCode = form?.dataset.currencyCode || 'CHF';
    let searchTimer;

    function escHtml(str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function formatPrice(amount) {
      return new Intl.NumberFormat('de-CH', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2
      }).format(amount);
    }

    function setFocusedItem(index) {
      const items = suggestions.querySelectorAll('.search-suggestion-item');
      items.forEach((item, i) => {
        const active = i === index;
        item.classList.toggle('is-focused', active);
        item.setAttribute('aria-selected', String(active));
      });
      currentFocus = index;
      if (index >= 0 && items[index]) {
        input.setAttribute('aria-activedescendant', items[index].id);
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function showSuggestions(products) {
      currentFocus = -1;
      if (products.length === 0) {
        suggestions.innerHTML = '<p class="search-suggestions__empty">Keine Produkte gefunden.</p>';
      } else {
        suggestions.innerHTML = products.map((p, i) => {
          const imgTag = p.image
            ? `<img src="${escHtml(p.image)}" alt="" class="search-suggestion-item__image" width="40" height="40" loading="lazy">`
            : '';
          const priceMin = parseFloat(p.price_min || p.price || '0');
          const priceMax = parseFloat(p.price_max || p.price || '0');
          const price = (priceMax > priceMin ? 'ab ' : '') + formatPrice(priceMin);
          return `<a href="${escHtml(p.url)}" class="search-suggestion-item" role="option" id="search-sugg-${i}" aria-selected="false">${imgTag}<div class="search-suggestion-item__body"><div class="search-suggestion-item__title">${escHtml(p.title)}</div><div class="search-suggestion-item__price">${price}</div></div></a>`;
        }).join('');
      }
      suggestions.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    input.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = input.value.trim();
      if (q.length < 2) { clearSuggestions(); return; }
      searchTimer = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`)
          .then(r => r.json())
          .then(data => showSuggestions(data?.resources?.results?.products || []))
          .catch(() => clearSuggestions());
      }, 250);
    });

    input.addEventListener('keydown', e => {
      if (suggestions.hidden) return;
      const items = suggestions.querySelectorAll('.search-suggestion-item');
      if (!items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setFocusedItem(Math.min(currentFocus + 1, items.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (currentFocus <= 0) {
          currentFocus = -1;
          input.removeAttribute('aria-activedescendant');
          items.forEach(item => { item.classList.remove('is-focused'); item.setAttribute('aria-selected', 'false'); });
        } else {
          setFocusedItem(currentFocus - 1);
        }
      } else if (e.key === 'Enter' && currentFocus >= 0) {
        e.preventDefault();
        items[currentFocus]?.click();
      }
    });

    input.addEventListener('blur', () => {
      setTimeout(() => {
        if (!drawer.contains(document.activeElement)) clearSuggestions();
      }, 150);
    });
  }

  function initMobileMenu() {
    const header = document.querySelector('.site-header');
    const toggle = document.querySelector('.mobile-menu-toggle');
    const nav = document.querySelector('.site-nav');
    if (!header || !toggle || !nav) return;

    const inertTargets = Array.from(document.body.children).filter(
      el => !el.contains(header)
    );

    function setRestInert(active) {
      inertTargets.forEach(el => {
        if (active) {
          el.setAttribute('inert', '');
          el.setAttribute('aria-hidden', 'true');
        } else {
          el.removeAttribute('inert');
          el.removeAttribute('aria-hidden');
        }
      });
    }

    function getNavLinks() {
      return Array.from(nav.querySelectorAll('.site-nav__link'));
    }

    function openMenu() {
      nav.classList.add('is-open');
      toggle.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Menü schliessen');
      document.body.style.overflow = 'hidden';
      setRestInert(true);
      requestAnimationFrame(() => nav.focus({ preventScroll: true }));
    }

    function closeMenu({ returnFocus = true } = {}) {
      nav.classList.remove('is-open');
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Menü öffnen');
      document.body.style.overflow = '';
      setRestInert(false);
      if (returnFocus) toggle.focus();
    }

    toggle.addEventListener('click', () => {
      if (nav.classList.contains('is-open')) closeMenu();
      else openMenu();
    });

    nav.querySelectorAll('.site-nav__link').forEach(link => {
      /* «Shop» klappt im Overlay nur auf (initShopMenue()), schliesst es nicht. */
      if (link.closest('[data-shop-menue]')) return;
      link.addEventListener('click', () => {
        if (nav.classList.contains('is-open')) closeMenu({ returnFocus: false });
      });
    });

    document.addEventListener('keydown', e => {
      if (!nav.classList.contains('is-open')) return;

      if (e.key === 'Escape') {
        e.preventDefault();
        closeMenu();
        return;
      }

      if (e.key === 'Tab') {
        const links = getNavLinks();
        if (links.length === 0) return;
        const first = links[0];
        const last = links[links.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herkunft"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const D3_SRC   = 'https://cdnjs.cloudflare.com/ajax/libs/d3/7.8.5/d3.min.js';
    const TOPO_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/topojson/3.0.2/topojson.min.js';
    const target = document.getElementById('home-map-svg');
    if (!target) return;

    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        const s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    function render() {
      const W = 960, H = 500;
      const cssVar = (name) => getComputedStyle(document.documentElement).getPropertyValue(name).trim();
      const mapOcean     = cssVar('--color-map-ocean');
      const mapLand      = cssVar('--color-map-land');
      const mapOrigin    = cssVar('--color-map-origin');
      const mapChrome    = cssVar('--color-map-chrome');
      const mapGraticule = cssVar('--color-map-graticule');
      const accent       = cssVar('--color-accent');
      // Feste Liste (Marc 2026-10-16: Länder ändern sich selten, keine Ladezeit).
      // Stand 2026-10-16: 29 Länder mit aktiven Produkten im Live-Shop, Werte
      // (ISO-Nummer, Länge, Breite) aus den Herkunfts-Einträgen. Neues
      // Herkunftsland → hier ergänzen (Weltkarten-Seite liest selbst).
      const LAENDER = [
        [ 32, -63.59, -38.42], // Argentinien
        [ 36, 133.78, -25.27], // Australien
        [100,  25.49,  42.73], // Bulgarien
        [854,  -1.75,  12.24], // Burkina Faso
        [152, -71.00, -35.00], // Chile
        [156, 104.20,  35.90], // China
        [276,  10.45,  51.17], // Deutschland
        [250,   2.21,  46.23], // Frankreich
        [826,  -2.00,  54.00], // Grossbritannien
        [356,  78.96,  20.59], // Indien
        [380,  12.57,  41.87], // Italien
        [404,  37.90,   0.02], // Kenia
        [418, 102.50,  17.90], // Laos
        [450,  46.87, -18.77], // Madagaskar
        [504,  -5.00,  32.00], // Marokko
        [540, 165.50, -21.30], // Neukaledonien
        [554, 172.00, -41.50], // Neuseeland
        [600, -58.40, -23.40], // Paraguay
        [643, 105.00,  60.00], // Russland
        [756,   8.20,  46.80], // Schweiz
        [706,  46.20,   6.00], // Somalia
        [724,  -3.70,  40.40], // Spanien
        [144,  80.70,   7.90], // Sri Lanka
        [710,  25.10, -29.00], // Südafrika
        [792,  35.24,  39.06], // Türkei
        [348,  19.50,  47.20], // Ungarn
        [704, 106.30,  16.00], // Vietnam
        [818,  30.80,  26.80], // Ägypten
        [ 40,  14.55,  47.52], // Österreich
      ];
      const ORIGIN_IDS = new Set(LAENDER.map(function (l) { return l[0]; }));
      const PINS = LAENDER.map(function (l) { return [l[1], l[2]]; });

      const svg  = d3.select('#home-map-svg');
      const proj = d3.geoNaturalEarth1().scale(185).translate([415, 248]);
      const path = d3.geoPath().projection(proj);
      const grat = d3.geoGraticule();

      svg.append('rect').attr('width', W).attr('height', H).attr('fill', mapOcean);
      svg.append('path').datum(grat()).attr('d', path)
        .attr('fill', 'none').attr('stroke', mapGraticule).attr('stroke-width', 0.5);

      d3.json('https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json').then(function (world) {
        const features = topojson.feature(world, world.objects.countries).features;

        svg.selectAll('.country').data(features).join('path')
          .attr('d', path)
          .attr('fill', function (d) { return ORIGIN_IDS.has(+d.id) ? mapOrigin : mapLand; })
          .attr('stroke', mapChrome).attr('stroke-width', 0.4);

        PINS.forEach(function ([lon, lat]) {
          const [x, y] = proj([lon, lat]);
          if (!x || !y) return;
          const g = svg.append('g').attr('transform', 'translate(' + x + ',' + y + ')');
          g.append('circle').attr('r', 7).attr('fill', accent).attr('opacity', 0.2);
          g.append('circle').attr('r', 4).attr('fill', accent);
          g.append('circle').attr('r', 1.5).attr('fill', cssVar('--color-bg'));
        });
      });
    }

    let loaded = false;
    const io = new IntersectionObserver(function (entries) {
      if (!loaded && entries[0].isIntersecting) {
        loaded = true;
        io.disconnect();
        Promise.all([loadScript(D3_SRC), loadScript(TOPO_SRC)])
          .then(render)
          .catch(function (err) { console.warn('Weltkarte konnte nicht geladen werden:', err); });
      }
    }, { rootMargin: '200px' });
    io.observe(target);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["passt-dazu"] && !Shopify.designMode) return;
  try {
    
(function () {
  function ziehen(kandidaten) {
    var n = kandidaten.length;
    var z = Math.random() * (n * (n + 1) / 2);
    for (var i = 0; i < n; i++) {
      z -= n - i;
      if (z < 0) return kandidaten[i];
    }
    return kandidaten[n - 1];
  }

  function fuellen(sektion, warenkorb) {
    var raster = sektion.querySelector('[data-pd-raster]');
    var plaetze = Array.prototype.slice.call(sektion.querySelectorAll('[data-pd-platz]'));
    var vergeben = new Set(warenkorb);
    var frei = function (platz) {
      return Array.prototype.slice.call(platz.querySelectorAll('[data-pd-kandidat]'))
        .filter(function (k) { return !vergeben.has(k.dataset.pid); });
    };
    var setzen = function (k) {
      vergeben.add(k.dataset.pid);
      if (k.firstElementChild) raster.appendChild(k.firstElementChild);
    };
    plaetze.forEach(function (platz) {
      var kandidaten = frei(platz);
      if (kandidaten.length) setzen(ziehen(kandidaten));
    });
    plaetze.forEach(function (platz) {
      if (raster.children.length >= 4) return;
      var kandidaten = frei(platz);
      if (kandidaten.length) setzen(kandidaten[0]);
    });
    plaetze.forEach(function (platz) { platz.remove(); });
    if (raster.children.length) sektion.hidden = false;
  }

  function start() {
    var sektionen = document.querySelectorAll('[data-passt-dazu]');
    if (!sektionen.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return (cart.items || []).map(function (i) { return String(i.product_id); }); })
      .catch(function () { return []; })
      .then(function (warenkorb) {
        sektionen.forEach(function (s) { fuellen(s, warenkorb); });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produkt-herkunft"]) return;
  try {
    
  (function () {
    var D3_SRC   = 'https://cdnjs.cloudflare.com/ajax/libs/d3/7.8.5/d3.min.js';
    var TOPO_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/topojson/3.0.2/topojson.min.js';
    var target = document.querySelector('.herkunft-karte-wrap[data-iso]');
    if (!target) return;

    // Land + ISO-3166-numerisch kommen direkt aus dem Herkunftsland-Metaobject
    // (custom.herkunft.value) — kein hartkodiertes Länder-Mapping mehr nötig.
    var landName = (target.getAttribute('data-land') || '').trim();
    var zielId = parseInt(target.getAttribute('data-iso'), 10);
    if (!zielId) { return; }

    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    function render() {
      var W = 240, H = 300, PAD = 40;
      var cssVar = function (name) { return getComputedStyle(document.documentElement).getPropertyValue(name).trim(); };
      var mapOcean  = cssVar('--color-map-ocean');
      var mapLand   = cssVar('--color-map-land');
      var mapChrome = cssVar('--color-map-chrome');

      // ISO → Polygone mit mittlerer Länge westlich dieses Werts weglassen (Kernland-Fokus).
      // 250 Frankreich: Übersee-Départements. 643 Russland: Tschukotka jenseits der
      // Datumsgrenze (sonst spannt fitExtent die Karte über die halbe Welt).
      var CLIP_WEST = { 250: -20, 643: 0 };
      function prepareFeature(f) {
        var minLon = CLIP_WEST[+f.id];
        if (minLon != null && f.geometry && f.geometry.type === 'MultiPolygon') {
          var filtered = f.geometry.coordinates.filter(function (poly) {
            var lons = poly[0].map(function (c) { return c[0]; });
            return lons.reduce(function (a, b) { return a + b; }, 0) / lons.length > minLon;
          });
          if (filtered.length !== f.geometry.coordinates.length) {
            return Object.assign({}, f, { geometry: { type: 'MultiPolygon', coordinates: filtered } });
          }
        }
        return f;
      }

      function buildSvg(ziel, alle) {
        ziel = prepareFeature(ziel);
        var proj = d3.geoMercator().fitExtent([[PAD, PAD], [W - PAD, H - PAD]], ziel);
        var pathGen = d3.geoPath().projection(proj);

        var svg = d3.create('svg')
          .attr('viewBox', '0 0 ' + W + ' ' + H)
          .attr('preserveAspectRatio', 'xMidYMid slice')
          .attr('aria-hidden', 'true');

        svg.append('rect').attr('width', W).attr('height', H).attr('fill', mapOcean);

        alle.forEach(function (f) {
          if (+f.id === zielId) return;
          svg.append('path').attr('d', pathGen(f))
            .attr('fill', mapLand).attr('stroke', mapChrome).attr('stroke-width', '0.4');
        });

        svg.append('path').attr('d', pathGen(ziel))
          .attr('fill', '#5aba82').attr('stroke', '#2d7050').attr('stroke-width', '0.8');

        var c = pathGen.centroid(ziel);
        var g = svg.append('g')
          .attr('transform', 'translate(' + c[0].toFixed(1) + ',' + c[1].toFixed(1) + ')');
        g.append('circle').attr('class', 'mini-pin-ring').attr('r', 5);
        g.append('circle').attr('class', 'mini-pin-bg').attr('r', 6);
        g.append('circle').attr('class', 'mini-pin-dot').attr('r', 2.5);
        g.append('text').attr('class', 'mini-pin-label')
          .attr('x', 11).attr('y', 0)
          .attr('text-anchor', 'start').attr('dominant-baseline', 'middle')
          .text(landName);

        return svg.node().outerHTML;
      }

      d3.json('https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json').then(function (world) {
        var features = topojson.feature(world, world.objects.countries).features;
        var ziel = features.find(function (f) { return +f.id === zielId; });
        if (!ziel) return;
        target.innerHTML = buildSvg(ziel, features);
      }).catch(function (err) { console.warn('Herkunft-Karte: Daten konnten nicht geladen werden:', err); });
    }

    var loaded = false;
    var io = new IntersectionObserver(function (entries) {
      if (!loaded && entries[0].isIntersecting) {
        loaded = true;
        io.disconnect();
        Promise.all([loadScript(D3_SRC), loadScript(TOPO_SRC)])
          .then(render)
          .catch(function (err) { console.warn('Herkunft-Karte konnte nicht geladen werden:', err); });
      }
    }, { rootMargin: '200px' });
    io.observe(target);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produkt-inhaltsstoffe"]) return;
  try {
    
  (function initInhaltsstoffeChart() {
    // Farbton = Funktionsklasse, Helligkeit = Molekuelgewicht (Stufe).
    // Quelle: docs/store-setup/inhaltsstoffe-farbkonzept.md
    var FARBEN = {
      'Terpene':   { mono: '#74B894', sesqui: '#4F9170', di: '#356B52' },
      'Alkohole':  { mono: '#E0A878', sesqui: '#D07A3A', aromatisch: '#A8541F' },
      'Aldehyde':  { mono: '#CFCB72', sesqui: '#B5B030', aromatisch: '#87831E' },
      'Ketone':    { mono: '#AEBCC8', sesqui: '#8A9BAA', di: '#5E6E7C' },
      'Ester':     { mono: '#DCBE6C', sesqui: '#C49A30', aromatisch: '#97751E' },
      'Oxide':     { mono: '#6AA8B8' },
      'Phenole':   { mono: '#9E80B2', aromatisch: '#6E4F84' },
      'Cumarine':  '#C8704C',
      'Andere':    '#BBBBA8'
    };

    // Beschreibungstexte je Funktionsklasse (Marc 2026-10-16, fachlich
    // gegengeprüft; Doku: docs/store-setup/inhaltsstoffe-texte-pruefung.md).
    // SSOT der Texte — HIER ändern, dann Theme deployen (KEIN Öl-Push nötig).
    var GRUPPEN_TEXTE = {
      'Terpene': 'Terpene sind die Grundbausteine vieler ätherischer Öle. Die leichten Monoterpene verfliegen schnell und bringen frische, oft zitrus- oder nadelholzartige Noten. Die schwereren Sesquiterpene verdunsten langsamer und sorgen für tiefere, holzige und warme Töne. Diterpene kommen nur selten und in kleinen Mengen vor.',
      'Alkohole': 'Terpenalkohole wie Linalool oder Geraniol gelten als gut verträglich, solange das Öl frisch ist. Sie duften meist mild und weich und geben vielen Ölen ihren runden Charakter. Aromatische Alkohole wie Phenylethylalkohol finden sich vor allem in Absolues und Hydrolaten, etwa aus der Rose.',
      'Aldehyde': 'Aldehyde duften intensiv frisch bis zitronig, etwa das Citral in Lemongrass oder Melisse. Schon kleine Mengen prägen den Duft eines Öls deutlich. Aromatische Aldehyde wie Vanillin oder Zimtaldehyd bringen süsse bis würzige Noten. Öle mit viel Aldehyd verdünnt man gut, weil sie die Haut reizen können.',
      'Ketone': 'Ketone bringen markante, oft kampfer- oder minzartige Noten, wie man sie von Salbei, Rosmarin oder Minze kennt. Je nach Verbindung dosiert man Öle mit viel Keton eher sparsam.',
      'Ester': 'Ester entstehen, wenn sich ein Alkohol mit einer Säure verbindet. Die meisten duften weich, fruchtig bis blumig und zählen zu den mildesten Stoffgruppen, etwa das Linalylacetat aus Lavendel und Bergamotte. Eine Ausnahme ist das Methylsalicylat aus Wintergrün, das man nur sehr sparsam verwendet.',
      'Oxide': 'Das bekannteste Oxid ist <span style="white-space: nowrap;">1,8-Cineol</span>. Es duftet frisch und klar nach Eukalyptus und gibt vielen Eukalyptus-, Myrten- und Cajeputölen ihren kühlen Eindruck. Die Bisabololoxide der Blauen Kamille duften dagegen viel milder.',
      'Phenole': 'Phenole wie Thymol oder Carvacrol duften würzig und kräftig und gehören zu den intensivsten Bestandteilen ätherischer Öle. Verwandte Phenylpropane wie Eugenol aus Nelke oder Anethol aus Anis bringen nelken- bis anisartige Noten. Öle mit viel Phenol verdünnt man gut, weil sie Haut und Schleimhaut reizen können.',
      'Cumarine': 'Cumarine und Furocumarine kommen vor allem in kaltgepressten Ölen aus Zitrusschalen vor, etwa in Bergamotte, Limette oder Zitrone. Furocumarine wie Bergapten können die Haut empfindlicher für Sonnenlicht machen. Darum zeigen wir sie als eigene Gruppe.',
      'Andere': 'Hier sind Spurenstoffe und seltenere Stoffgruppen zusammengefasst, etwa Säuren, andere Lactone oder Verbindungen, die sich nicht eindeutig zuordnen lassen. Einzeln machen sie meist weniger als ein Prozent aus.'
    };

    function gruppenfarbe(item) {
      var f = FARBEN[item.gruppe];
      if (!f) return '#999999';
      if (typeof f === 'string') return f;
      return f[item.stufe] || f.mono || '#999999';
    }

    var dataEl = document.querySelector('[data-inhalt-data]');
    if (!dataEl) return;
    var INHALTSSTOFFE;
    try {
      INHALTSSTOFFE = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!INHALTSSTOFFE || !INHALTSSTOFFE.length) return;

    function describeArc(cx, cy, R, r, a0, a1) {
      var c = Math.cos, s = Math.sin;
      var la = (a1 - a0) > Math.PI ? 1 : 0;
      return [
        'M ' + (cx + R * c(a0)) + ' ' + (cy + R * s(a0)),
        'A ' + R + ' ' + R + ' 0 ' + la + ' 1 ' + (cx + R * c(a1)) + ' ' + (cy + R * s(a1)),
        'L ' + (cx + r * c(a1)) + ' ' + (cy + r * s(a1)),
        'A ' + r + ' ' + r + ' 0 ' + la + ' 0 ' + (cx + r * c(a0)) + ' ' + (cy + r * s(a0)),
        'Z'
      ].join(' ');
    }

    var svg       = document.getElementById('inhalt-chart');
    var legendEl  = document.getElementById('inhalt-legend');
    var infoPanel = document.getElementById('inhalt-info');
    var chartWrap = document.getElementById('inhalt-chart-wrap');
    if (!svg || !legendEl || !infoPanel || !chartWrap) return;

    var cx = 160, cy = 160, R = 130, r = 72;
    var lockedIdx = null;
    var currentIdx = null;
    var paths = [];

    var maxIdx = 0;
    for (var mi = 1; mi < INHALTSSTOFFE.length; mi++) {
      if (parseFloat(INHALTSSTOFFE[mi].prozent) > parseFloat(INHALTSSTOFFE[maxIdx].prozent)) { maxIdx = mi; }
    }

    var angle = -Math.PI / 2;
    INHALTSSTOFFE.forEach(function (item, i) {
      var sweep = (item.prozent / 100) * 2 * Math.PI;
      var gap = sweep > 0.1 ? 0.013 : 0;
      var a0  = angle + gap;
      var a1  = angle + sweep - gap;
      var mid = angle + sweep / 2;
      var ox  = parseFloat((Math.cos(mid) * 13).toFixed(2));
      var oy  = parseFloat((Math.sin(mid) * 13).toFixed(2));

      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', describeArc(cx, cy, R, r, a0, a1));
      path.setAttribute('fill', gruppenfarbe(item));
      path.setAttribute('stroke', 'none');
      path.setAttribute('class', 'inhalt-segment');
      path.setAttribute('tabindex', '0');
      path.setAttribute('role', 'button');
      path.setAttribute('aria-label', item.name + ': ' + item.bereich);
      path.style.transitionDelay = (i * 0.07) + 's';
      svg.appendChild(path);
      paths.push({ el: path, ox: ox, oy: oy });
      angle += sweep;

      path.addEventListener('mousedown', function (e) { e.preventDefault(); });
      path.addEventListener('mouseenter', function () { highlight(i); });
      path.addEventListener('mouseleave', function () { if (lockedIdx !== null) { highlight(lockedIdx); } });
      path.addEventListener('click', function () { toggleLock(i); });
      path.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleLock(i); }
      });

      var li = document.createElement('li');
      li.className = 'inhalt-legend-item';
      li.setAttribute('tabindex', '0');
      li.setAttribute('role', 'button');
      li.setAttribute('aria-pressed', 'false');
      li.setAttribute('aria-label', item.name + ', ' + item.bereich + ' — Details einblenden');
      li.innerHTML = '<span class="inhalt-legend-dot" style="background:' + gruppenfarbe(item) + '"></span><span>' + item.name + '</span>';
      li.addEventListener('mousedown', function (e) { e.preventDefault(); });
      li.addEventListener('mouseenter', function () { highlight(i); });
      li.addEventListener('mouseleave', function () { if (lockedIdx !== null) { highlight(lockedIdx); } });
      li.addEventListener('click', function () { toggleLock(i); });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleLock(i); }
      });
      legendEl.appendChild(li);
    });

    function highlight(idx) {
      paths.forEach(function (p, i) {
        if (i === idx) {
          p.el.style.transform = 'translate(' + p.ox + 'px,' + p.oy + 'px)';
          p.el.style.opacity   = '1';
        } else {
          p.el.style.transform = '';
          p.el.style.opacity   = '0.35';
        }
      });
      legendEl.querySelectorAll('.inhalt-legend-item').forEach(function (li, i) {
        var isActive = i === idx;
        li.classList.toggle('is-active', isActive);
        li.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      if (currentIdx !== idx) { showInfo(INHALTSSTOFFE[idx]); }
      currentIdx = idx;
    }

    function toggleLock(idx) {
      lockedIdx = idx;
      if (currentIdx !== idx) { highlight(idx); }
    }

    function panelTransition(newHTML, afterCallback) {
      var inner = infoPanel.querySelector('.inhalt-inner');
      function insertNew() {
        infoPanel.innerHTML = '<div class="inhalt-inner">' + newHTML + '</div>';
        if (afterCallback) afterCallback();
      }
      if (!inner) { insertNew(); return; }
      inner.style.animation = 'inhaltNachRechts 0.18s ease forwards';
      setTimeout(insertNew, 175);
    }

    // Nur Stoffgruppen: Name, Anteil, Erklärtext (Quellenzeile entfernt,
    // Marc 2026-10-16). Die Einzel-
    // Verbindungen (item.verbindungen) stehen weiter in den Daten, werden aber
    // nicht angezeigt (Marc 2026-10-16); die ganze Liste steht in der Analyse.
    function buildPanel(item) {
      var txt = GRUPPEN_TEXTE[item.gruppe] || '';
      return '<div class="inhalt-info-header">' +
               '<span class="inhalt-info-dot" style="background:' + gruppenfarbe(item) + '"></span>' +
               '<h3 class="inhalt-info-name">' + item.name + '</h3>' +
               '<span class="inhalt-info-pct">' + item.bereich + '</span>' +
             '</div>' +
             (txt ? '<p class="inhalt-info-text">' + txt + '</p>' : '');
    }

    function showInfo(item) {
      var live = document.getElementById('inhalt-announce');
      if (live) live.textContent = item.name;
      panelTransition(buildPanel(item));
    }

    function teaserHTML() {
      return '<div class="inhalt-teaser">' +
               buildPanel(INHALTSSTOFFE[maxIdx]) +
               '<div class="inhalt-teaser-fade" aria-hidden="true"></div>' +
             '</div>' +
             '<p class="inhalt-teaser-hint"><span aria-hidden="true">←</span> Wähle ein Segment für Details</p>';
    }

    function showDefault() {
      panelTransition(teaserHTML());
    }

    // Kachel-Höhe: so hoch wie der längste Gruppentext dieses Öls, damit sie
    // beim Wechsel nicht springt und nicht grösser ist als nötig (Marc
    // 2026-10-16). Der Startzustand passt sich ein (.inhalt-teaser schrumpft).
    // Neu messen, wenn die Schrift geladen ist oder sich die Breite ändert.
    function setzeKachelHoehe() {
      var vorher = infoPanel.innerHTML;
      var max = 0;
      infoPanel.style.minHeight = '';
      INHALTSSTOFFE.forEach(function (item) {
        infoPanel.innerHTML = '<div class="inhalt-inner">' + buildPanel(item) + '</div>';
        max = Math.max(max, infoPanel.offsetHeight);
      });
      infoPanel.innerHTML = vorher;
      infoPanel.style.minHeight = max + 'px';
    }

    setzeKachelHoehe();
    showDefault();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setzeKachelHoehe);
    }
    var letzteBreite = window.innerWidth;
    var resizeTimer;
    window.addEventListener('resize', function () {
      if (window.innerWidth === letzteBreite) return;
      letzteBreite = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setzeKachelHoehe, 150);
    });

    var chartObserver = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        chartWrap.classList.add('visible');
        chartObserver.unobserve(chartWrap);
        setTimeout(function () { toggleLock(maxIdx); }, INHALTSSTOFFE.length * 70 + 250);
      }
    }, { threshold: 0.25 });
    chartObserver.observe(chartWrap);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produkt-kollektion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const knopf = document.querySelector('[data-nach-oben]');
    if (!knopf) return;
    const pruefen = () => { knopf.hidden = window.scrollY < 600; };
    window.addEventListener('scroll', pruefen, { passive: true });
    pruefen();
    knopf.addEventListener('click', () => {
      const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: ruhig ? 'auto' : 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warenkorb-drawer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', initCartDrawer);

  function initCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    const backdrop = document.getElementById('cart-drawer__backdrop');
    const toggle = document.getElementById('cart-toggle');
    if (!drawer || !toggle) return;

    const closeBtn = drawer.querySelector('.cart-drawer__close');
    const countEl = document.querySelector('[data-cart-count]');
    const sectionId = drawer.dataset.sectionId;

    const open = () => {
      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      backdrop && backdrop.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => closeBtn && closeBtn.focus());
    };

    const close = ({ returnFocus = true } = {}) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      backdrop && backdrop.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (returnFocus) toggle.focus();
    };

    // Warenkorb-Icon: Klick abfangen → Drawer öffnen statt zu /cart navigieren
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      if (drawer.classList.contains('is-open')) close();
      else open();
    });

    closeBtn && closeBtn.addEventListener('click', () => close());
    backdrop && backdrop.addEventListener('click', () => close());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        e.preventDefault();
        close();
      }
    });

    // Frisch gerenderten Drawer-Body (aus Bundled-Section-Response) übernehmen + Zähler setzen
    function applyCartUpdate(sections, itemCount) {
      if (sections && sections[sectionId]) {
        const fresh = new DOMParser()
          .parseFromString(sections[sectionId], 'text/html')
          .querySelector('[data-cart-drawer-body]');
        const live = drawer.querySelector('[data-cart-drawer-body]');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
      }
      if (countEl && typeof itemCount === 'number') {
        countEl.textContent = itemCount;
        countEl.hidden = itemCount === 0;
      }
    }

    function changeLine(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
          sections: sectionId,
          sections_url: window.location.pathname
        })
      })
        .then((r) => r.json())
        .then((cart) => applyCartUpdate(cart.sections, cart.item_count))
        .catch(() => {});
    }

    // Event-Delegation: Body wird nach jeder Mutation neu gerendert
    drawer.addEventListener('click', (e) => {
      const item = e.target.closest('.cart-item');
      if (!item) return;
      const stepper = item.querySelector('.qty-stepper[data-item-key]');
      if (!stepper) return;
      const key = stepper.dataset.itemKey;
      const valEl = stepper.querySelector('.qty-stepper__val');
      const current = parseInt(valEl.textContent, 10) || 0;

      if (e.target.closest('.qty-stepper__btn--minus')) {
        changeLine(key, Math.max(0, current - 1));
      } else if (e.target.closest('.qty-stepper__btn--plus')) {
        changeLine(key, current + 1);
      } else if (e.target.closest('.cart-item__remove')) {
        e.preventDefault();
        changeLine(key, 0);
      }
    });

    // Stiller Refresh, wenn anderswo per AJAX ein Artikel hinzugefügt wurde
    document.addEventListener('cart:updated', (e) => {
      const detail = e.detail || {};
      applyCartUpdate(detail.sections, detail.itemCount);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weltkarte"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var D3_SRC   = 'https://cdnjs.cloudflare.com/ajax/libs/d3/7.8.5/d3.min.js';
    var TOPO_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/topojson/3.0.2/topojson.min.js';

    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        if (document.querySelector('script[src="' + src + '"]')) { resolve(); return; }
        var s = document.createElement('script');
        s.src = src; s.onload = resolve; s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    function boot() {
      if (!document.getElementById('map-svg')) return;

      var rawProducts = [];
      var dataEl = document.getElementById('weltkarte-data');
      if (dataEl) { try { rawProducts = JSON.parse(dataEl.textContent) || []; } catch (e) { rawProducts = []; } }

      // Ländercode → Flaggendatei; fehlt der Eintrag, bleibt die Flagge einfach weg
      var FLAGGEN = {};
      var flaggenEl = document.getElementById('weltkarte-flaggen');
      if (flaggenEl) { try { FLAGGEN = JSON.parse(flaggenEl.textContent) || {}; } catch (e) { FLAGGEN = {}; } }

      // Produkte nach ISO-Land gruppieren; Länderdaten kommen aus dem Metaobject-JSON
      var DATA = {};
      var seen = {};
      rawProducts.forEach(function (p) {
        if (!p.iso) return;                 // Öl ohne Herkunft: nicht auf die Karte
        var key = String(p.iso);
        if (p.id != null) { if (seen[p.id]) return; seen[p.id] = true; }
        if (!DATA[key]) {
          DATA[key] = { region: p.region, country: p.country, desc: p.desc,
                        coords: [Number(p.lng), Number(p.lat)], continent: p.continent,
                        flaggeUrl: FLAGGEN[p.flagge] || '',
                        ids: [Number(p.iso)], products: [] };
        }
        DATA[key].products.push({ name: p.name || '', latin: p.latin || '', tag: p.tag || '', scent: p.scent || '', art: p.art || '', url: p.url || '#', bild: p.bild || '' });
      });

      Promise.all([loadScript(D3_SRC), loadScript(TOPO_SRC)])
        .then(function () { init(DATA); })
        .catch(function (err) { console.warn('Weltkarte konnte nicht geladen werden:', err); });
    }

    function init(DATA) {
      var idToKey = {};
      Object.entries(DATA).forEach(function (e) { e[1].ids.forEach(function (id) { idToKey[id] = e[0]; }); });
      var originIds = new Set(Object.values(DATA).flatMap(function (v) { return v.ids; }));

      var W = 960, H = 500;
      var svg  = d3.select('#map-svg');
      var tip  = document.getElementById('map-tip');
      var wrap = document.querySelector('.map-wrapper');

      // Produktarten, adressiert über das Handle der Quell-Collection. Kommt eine
      // vierte Collection dazu, gehört sie hier ergänzt — sonst greift ART_FALLBACK.
      var ARTEN = {
        'aetherische-oele':   { ein: 'ätherisches Öl',   viele: 'ätherische Öle',   farbe: 'var(--art-aetherisch)', istOel: true  },
        'fette-pflanzenoele': { ein: 'fettes Pflanzenöl', viele: 'fette Pflanzenöle', farbe: 'var(--art-fett)',      istOel: true  },
        'hydrolate':          { ein: 'Hydrolat',          viele: 'Hydrolate',        farbe: 'var(--art-hydrolat)',   istOel: false }
      };
      var ART_FALLBACK = { ein: 'Produkt', viele: 'Produkte', farbe: 'var(--color-accent)', istOel: true };

      function artFarbe(art) { return (ARTEN[art] || ART_FALLBACK).farbe; }

      // Werte aus dem Produkt-JSON landen per innerHTML in der Liste
      function esc(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      // Benennt, was tatsächlich hinter der Zahl steht: bei nur einer Art deren Name,
      // bei mehreren Ölarten «Öle», sobald Hydrolate dazukommen «Öle & Hydrolate».
      // Der Singular kann dadurch nur im ersten Fall auftreten.
      function produktLabel(products) {
        var arten = {};
        products.forEach(function (p) { arten[p.art] = true; });
        var keys = Object.keys(arten);
        if (keys.some(function (k) { return !ARTEN[k]; })) {
          return products.length === 1 ? ART_FALLBACK.ein : ART_FALLBACK.viele;
        }
        if (keys.length === 1) {
          return products.length === 1 ? ARTEN[keys[0]].ein : ARTEN[keys[0]].viele;
        }
        return keys.some(function (k) { return !ARTEN[k].istOel; }) ? 'Öle & Hydrolate' : 'Öle';
      }

      var WORLD_SCALE = 153;
      var current = null;

      // Startansicht: auf schmalen Geraeten fuellt die Weltansicht die Hoehe nicht,
      // weil die viewBox auf die Breite eingepasst wird. Dort wird herangezoomt.
      // Laenge 43.3 = nach Oel-Anzahl gewichteter Schwerpunkt der Herkunftslaender;
      // der Deckel 2.0 haelt Australien (19 Oele) im Bild — bei 2.5 faellt es raus.
      // Breite 0 (Aequator) haelt die Karte vertikal mittig: die Projektion ist um den
      // Aequator symmetrisch, und in der Hoehe ist ohnehin die ganze Karte sichtbar —
      // auf den Schwerpunkt-Breitengrad zentriert haenge sie sonst nach unten durch.
      var START_CENTER = [43.3, 0];
      var START_ZOOM_MAX = 2;      // Deckel: haelt Australien (19 Oele) im Bild
      var START_ZOOM_MIN = 1.3;    // darunter lohnt es nicht — Desktop liegt bei ~1.07
      var startTransform = d3.zoomIdentity;
      var FEATURES = {};             // ISO → bereinigtes topojson-Feature, für zoomToCountry
      var COUNTRY_ZOOM_MIN = 2;      // auch grosse Länder sollen spürbar heranzoomen
      var COUNTRY_ZOOM_MAX = 8;      // kleine Länder nicht ins Leere springen lassen
      var IS_TOUCH = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
      var PIN_POS = {};
      var PIN_BASE = IS_TOUCH ? 1.6 : 1;
      var PIN_GROWTH_CAP = IS_TOUCH ? 3 : 1;

      function pinScale(k) { return PIN_BASE * Math.min(k, PIN_GROWTH_CAP) / k; }

      // Label-Platzierung: vollautomatisch, keine handgepflegten Länderlisten.
      // Priorität = Anzahl Öle des Landes, aktives Land immer zuerst.
      var LABEL_REF_SIZE = 6.5;   // Referenzgrösse, in der die Textmetrik gemessen wird
      var LABEL_MAX_SIZE = 10;    // ab Zoomfaktor LABEL_SIZE_K erreicht
      var LABEL_SIZE_K   = 4;
      var LABEL_HALO     = 3;     // stroke-width der .pin-label-Kontur
      var LABEL_GAP      = 11;    // horizontaler Abstand Pin-Mitte → Textkante
      var PIN_R_LOCAL    = IS_TOUCH ? 3 : 6;   // sichtbarer Pin-Radius, Touch via scale(0.5)
      var LABEL_METRICS  = {};    // key → { w, h } bei LABEL_REF_SIZE
      var LABEL_STATE    = {};    // key → { cand, shown, size }
      var labelRaf = null;

      var proj    = d3.geoNaturalEarth1().scale(WORLD_SCALE).translate([W / 2, H / 2]).precision(0.2);
      var pathGen = d3.geoPath().projection(proj);
      var graticule = d3.geoGraticule();

      var mapG = svg.append('g').attr('id', 'map-g');
      mapG.append('path').datum({ type: 'Sphere' }).attr('class', 'sphere').attr('d', pathGen);
      mapG.append('path').datum(graticule()).attr('class', 'graticule').attr('d', pathGen);
      var countriesG = mapG.append('g');
      var pinsG      = mapG.append('g');

      function onZoomStart(event) {
        if (!event.sourceEvent) return;
        hideTip();
      }

      function onZoom(event) {
        var t = event.transform;
        mapG.attr('transform', t.toString());
        mapG.node().style.setProperty('--inv-k', 1 / t.k);
        pinsG.selectAll('.pin-group').each(function () {
          var k = this.id.replace('pin-', '');
          var pos = PIN_POS[k];
          if (!pos) return;
          d3.select(this).attr('transform', 'translate(' + pos[0] + ',' + pos[1] + ') scale(' + pinScale(t.k) + ')');
        });
        updateZoomButtons(t.k);
        scheduleLabels();
      }

      // Startansicht aus der tatsächlichen Kartenfläche ableiten: schmale, hohe
      // Container (Handy) bekommen einen Startzoom, breite bleiben bei der Weltansicht.
      function berechneStartansicht() {
        var box = svg.node().getBoundingClientRect();
        if (!(box.width > 0) || !(box.height > 0)) return d3.zoomIdentity;
        var fit = Math.min(box.width / W, box.height / H);
        if (!(fit > 0)) return d3.zoomIdentity;
        var kFuell = box.height / (H * fit);       // würde die Höhe ganz ausfüllen
        if (kFuell < START_ZOOM_MIN) return d3.zoomIdentity;
        var k = Math.min(kFuell, START_ZOOM_MAX);
        var p = proj(START_CENTER);
        return d3.zoomIdentity.translate(W / 2, H / 2).scale(k).translate(-p[0], -p[1]);
      }

      function istStartansicht(t) {
        return Math.abs(t.k - startTransform.k) <= 0.02 * startTransform.k &&
               Math.abs(t.x - startTransform.x) <= 2 &&
               Math.abs(t.y - startTransform.y) <= 2;
      }

      function onZoomEnd(event) {
        if (!event.sourceEvent) return;
        var hint = document.getElementById('zoom-hint');
        var hintLabel = document.getElementById('zoom-hint-label');
        var t = event.transform;
        // Knapp neben der Weltansicht sauber einrasten — nur dort, wo sie auch die
        // Startansicht ist; sonst würde es das Pannen auf dem Handy zurückreissen.
        if (startTransform.k === 1 && t.k <= 1.02 && t.k !== 1) {
          svg.transition().duration(200).call(zoomBehavior.transform, d3.zoomIdentity);
        }
        if (istStartansicht(t)) {
          hint.classList.remove('show');
        } else {
          if (current && DATA[current]) {
            hintLabel.hidden = false;
            hintLabel.textContent = DATA[current].country;
          } else {
            hintLabel.textContent = '';
            hintLabel.hidden = true;
          }
          hint.classList.add('show');
        }
        scheduleLabels();
      }

      // Sichtfeld in viewBox-Einheiten. Fest [[0,0],[W,H]] würde behaupten, die viewBox
      // fülle das Element exakt aus — durch preserveAspectRatio ragt das Sichtfeld auf
      // schmalen Geräten aber weit darüber hinaus. Mit dem echten Wert zentriert d3 die
      // Karte in der Richtung, in der Platz übrig ist, statt sie an eine Kante zu klemmen.
      function sichtExtent() {
        var box = svg.node().getBoundingClientRect();
        var fit = Math.min(box.width / W, box.height / H);
        if (!(fit > 0)) return [[0, 0], [W, H]];
        var vw = box.width / fit, vh = box.height / fit;
        return [[(W - vw) / 2, (H - vh) / 2], [(W + vw) / 2, (H + vh) / 2]];
      }

      var zoomBehavior = d3.zoom()
        .scaleExtent([1, 16])
        .translateExtent([[0, 0], [W, H]])
        .extent(sichtExtent)
        .filter(function (event) {
          // Touch: ein Finger scrollt die Seite, erst zwei Finger bewegen die Karte.
          // Maus/Trackpad: Rad zoomt (auch als ctrl+wheel-Pinch), linke Taste zieht.
          if (event.type === 'touchstart') return event.touches.length >= 2;
          if (event.type === 'wheel')      return true;
          if (event.type === 'mousedown')  return event.button === 0;
          return !event.ctrlKey && !event.button;
        })
        .on('start', onZoomStart)
        .on('zoom', onZoom)
        .on('end', onZoomEnd);

      // d3 unterdrückt das Scrollen nur, wenn sich der Zoom auch ändert — am Anschlag
      // (k = 1 bzw. 16) würde die Seite sonst unter dem Cursor wegscrollen. Dieser
      // Listener steht bewusst vor dem Zoom-Handler, damit ihn dessen
      // stopImmediatePropagation nicht überspringt.
      svg.node().addEventListener('wheel', function (ev) { ev.preventDefault(); }, { passive: false });

      // dblclick bleibt aus: ein einfacher Klick auf ein Land zoomt bereits dorthin
      svg.call(zoomBehavior).on('dblclick.zoom', null);
      if (!IS_TOUCH) {
        svg.on('touchstart.zoom', null).on('touchmove.zoom', null).on('touchend.zoom touchcancel.zoom', null);
      }

      // Textbreite jedes Labels einmalig bei LABEL_REF_SIZE messen. Muss nach dem Laden
      // des Webfonts wiederholt werden, weil sich die Breite dann ändert.
      function measureLabels() {
        pinsG.selectAll('.pin-group').each(function () {
          var key = this.id.replace('pin-', '');
          var el = d3.select(this).select('.pin-label').node();
          if (!el) return;
          el.setAttribute('font-size', LABEL_REF_SIZE);
          if (LABEL_STATE[key]) LABEL_STATE[key].size = null;   // Attribute neu schreiben lassen
          var w = 0;
          try { w = el.getBBox().width; } catch (e) { w = 0; }
          if (!(w > 0)) {                      // Karte noch nicht gerendert: Breite schätzen
            LABEL_METRICS[key] = { w: (el.textContent || '').length * 0.62 * LABEL_REF_SIZE + LABEL_HALO,
                                   h: LABEL_REF_SIZE * 1.2 + LABEL_HALO };
            return;
          }
          w += LABEL_HALO;                     // die Kontur (paint-order: stroke) zählt mit
          // Höhe über das Seitenverhältnis der gerenderten Box: getBBox() liefert die volle
          // Font-Box inkl. Unterlängen, die bei uppercase gar nicht gezeichnet werden.
          // Das Verhältnis ist skalierungsunabhängig, deshalb hier gültig für jeden Zoom.
          var r = el.getBoundingClientRect();
          var h = r.width > 0 ? w * (r.height / r.width) : LABEL_REF_SIZE * 1.2 + LABEL_HALO;
          LABEL_METRICS[key] = { w: w, h: h };
        });
      }

      // Gesamt-Skala eines Labels auf dem Bildschirm: Pin-Gruppe (pinScale) × Karte (k).
      function labelScale(k) { return PIN_BASE * Math.min(k, PIN_GROWTH_CAP); }

      // Stufenlos statt binär: 6.5px in der Weltansicht → 10px ab Zoomfaktor 4.
      function labelFontSize(k) {
        var f = (k - 1) / (LABEL_SIZE_K - 1);
        if (f < 0) f = 0; else if (f > 1) f = 1;
        return LABEL_REF_SIZE + (LABEL_MAX_SIZE - LABEL_REF_SIZE) * f;
      }

      // Vier Kandidatenpositionen in lokalen Pin-Gruppen-Einheiten. Der vertikale Abstand
      // hängt von der Texthöhe ab, damit oben/unten nie den eigenen Pin überdeckt.
      function labelCandidates(metric, sizeFactor) {
        var vOff = PIN_R_LOCAL + 3 + (metric.h * sizeFactor) / 2;
        return [
          { dx:  LABEL_GAP, dy: 0,     anchor: 'start'  },
          { dx: -LABEL_GAP, dy: 0,     anchor: 'end'    },
          { dx: 0,          dy: -vOff, anchor: 'middle' },
          { dx: 0,          dy: vOff,  anchor: 'middle' }
        ];
      }

      // Rechteck im viewBox-Raum (960×500) — rein rechnerisch, ohne Layout-Read.
      function labelRect(key, t, S, sizeFactor, metric, cand) {
        var pos = PIN_POS[key];
        var sx = t.x + t.k * pos[0];
        var sy = t.y + t.k * pos[1];
        var w  = metric.w * sizeFactor * S;
        var h  = metric.h * sizeFactor * S;
        var cx = sx + cand.dx * S;
        var cy = sy + cand.dy * S;
        var x0 = cand.anchor === 'start' ? cx : (cand.anchor === 'end' ? cx - w : cx - w / 2);
        return { x0: x0, x1: x0 + w, y0: cy - h / 2, y1: cy + h / 2 };
      }

      function placeLabels() {
        var t = d3.zoomTransform(svg.node());
        var S = labelScale(t.k);
        var fontSize = labelFontSize(t.k);
        var sizeFactor = fontSize / LABEL_REF_SIZE;

        // Sichtbarer Bereich in viewBox-Einheiten. Durch preserveAspectRatio ("meet")
        // ragt die Elementbox über die viewBox hinaus — bei k > 1 ist dieser Überhang
        // voll mit Karte gefüllt, Labels dürfen dort stehen. Ein Layout-Read pro Durchlauf.
        var box = svg.node().getBoundingClientRect();
        var fit = Math.min(box.width / W, box.height / H);
        var overX = 0, overY = 0;
        if (fit > 0) { overX = (box.width / fit - W) / 2; overY = (box.height / fit - H) / 2; }

        var items = [];
        pinsG.selectAll('.pin-group').each(function () {
          var key = this.id.replace('pin-', '');
          var el = d3.select(this).select('.pin-label').node();
          if (!el) return;
          if (parseFloat(this.style.opacity) < 0.5) return;   // Pin noch im Einflug
          if (!LABEL_METRICS[key] || !PIN_POS[key]) return;
          items.push({ key: key, el: el,
                       count: DATA[key] ? DATA[key].products.length : 0,
                       country: DATA[key] ? DATA[key].country : '' });
        });

        // Priorität: aktives Land, dann Öl-Anzahl, dann Name (deterministisch, damit
        // gleich grosse Länder zwischen zwei Durchläufen nicht die Plätze tauschen).
        items.sort(function (a, b) {
          if (a.key === current) return -1;
          if (b.key === current) return 1;
          if (b.count !== a.count) return b.count - a.count;
          return a.country.localeCompare(b.country, 'de');
        });

        // Pins belegen Fläche: kein Label darf auf einem fremden Pin liegen.
        var pinR = PIN_R_LOCAL * S + 1;
        var blockers = [];
        items.forEach(function (it) {
          var pos = PIN_POS[it.key];
          var sx = t.x + t.k * pos[0], sy = t.y + t.k * pos[1];
          blockers.push({ x0: sx - pinR, x1: sx + pinR, y0: sy - pinR, y1: sy + pinR, key: it.key });
        });

        function hits(r, pad, ownKey) {
          for (var i = 0; i < blockers.length; i++) {
            var b = blockers[i];
            if (b.key === ownKey) continue;
            if (r.x1 + pad > b.x0 && b.x1 + pad > r.x0 &&
                r.y1 + pad > b.y0 && b.y1 + pad > r.y0) return true;
          }
          return false;
        }

        items.forEach(function (it) {
          var metric = LABEL_METRICS[it.key];
          var state  = LABEL_STATE[it.key] || (LABEL_STATE[it.key] = { cand: 0, shown: false, size: null });
          // Pin ausserhalb des Bildes → Label ohne sichtbaren Bezugspunkt, weglassen
          var pp = PIN_POS[it.key];
          var psx = t.x + t.k * pp[0], psy = t.y + t.k * pp[1];
          if (psx < -overX || psx > W + overX || psy < -overY || psy > H + overY) {
            if (state.shown) { it.el.style.opacity = '0'; state.shown = false; }
            return;
          }
          var cands  = labelCandidates(metric, sizeFactor);
          // Hysterese: ein sichtbares Label muss deutlicher überlappen, bevor es geht.
          var pad = state.shown ? 1 : 4;
          // Zuletzt genutzte Position zuerst prüfen — verhindert Springen beim Zoomen.
          var order = [state.cand, 0, 1, 2, 3];
          // Durchgang 1 nimmt nur vollständig sichtbare Positionen (am Rand kippt das
          // Label dadurch von selbst nach innen). Erst wenn keine passt, erlaubt
          // Durchgang 2 einen Anschnitt — der Pin ist ja sichtbar.
          var chosen = -1, rect = null;
          for (var pass = 0; pass < 2 && chosen < 0; pass++) {
            for (var i = 0; i < order.length; i++) {
              var r = labelRect(it.key, t, S, sizeFactor, metric, cands[order[i]]);
              if (pass === 0 && (r.x0 < -overX || r.x1 > W + overX ||
                                 r.y0 < -overY || r.y1 > H + overY)) continue;
              if (hits(r, pad, it.key)) continue;
              chosen = order[i]; rect = r; break;
            }
          }
          if (chosen < 0) {
            // Das ausgewählte Land behält seinen Namen immer — notfalls überlappend.
            // Sonst verschwindet er beim Herauszoomen, sobald fremde Pins dicht stehen.
            if (it.key === current) {
              chosen = order[0];
              rect = labelRect(it.key, t, S, sizeFactor, metric, cands[chosen]);
            } else {
              if (state.shown) { it.el.style.opacity = '0'; state.shown = false; }
              return;
            }
          }
          blockers.push({ x0: rect.x0, x1: rect.x1, y0: rect.y0, y1: rect.y1, key: it.key });
          if (state.cand !== chosen || state.size !== fontSize) {
            var c = cands[chosen];
            it.el.setAttribute('x', c.dx);
            it.el.setAttribute('y', c.dy);
            it.el.setAttribute('text-anchor', c.anchor);
            it.el.setAttribute('font-size', fontSize);
            state.cand = chosen;
            state.size = fontSize;
          }
          if (!state.shown) { it.el.style.opacity = '1'; state.shown = true; }
        });
      }

      // Pro Frame höchstens ein Durchlauf — trägt den Pinch-Zoom und die Zoom-Animationen.
      function scheduleLabels() {
        if (labelRaf) return;
        labelRaf = requestAnimationFrame(function () { labelRaf = null; placeLabels(); });
      }

      function showTip(event, html) { if (IS_TOUCH) return; tip.innerHTML = html; tip.classList.add('show'); moveTip(event); }
      function hideTip() { tip.classList.remove('show'); }
      function moveTip(event) {
        var r = wrap.getBoundingClientRect();
        tip.style.left = (event.clientX - r.left - tip.offsetWidth / 2) + 'px';
        tip.style.top  = (event.clientY - r.top - 46) + 'px';
      }

      // Zoomstufe aus der Ausdehnung des Landes: Luxemburg braucht eine andere als Russland.
      function countryZoom(key) {
        var f = FEATURES[key];
        if (!f) return COUNTRY_ZOOM_MIN;
        var b = pathGen.bounds(f);
        var dx = b[1][0] - b[0][0], dy = b[1][1] - b[0][1];
        if (!(dx > 0) || !(dy > 0)) return COUNTRY_ZOOM_MIN;
        var k = 0.9 / Math.max(dx / W, dy / H);
        return Math.max(COUNTRY_ZOOM_MIN, Math.min(COUNTRY_ZOOM_MAX, k));
      }

      // Zentriert wird auf den Pin, nicht auf den Geometrie-Schwerpunkt: bei Russland
      // sitzt der Pin in Sibirien, der Schwerpunkt läge weit daneben.
      function zoomToCountry(key) {
        var pos = PIN_POS[key];
        if (!pos) return;
        hideTip();
        var k = countryZoom(key);
        var t = d3.zoomIdentity.translate(W / 2, H / 2).scale(k).translate(-pos[0], -pos[1]);
        // Die Zoom-Transition feuert pro Frame zoom-Events → placeLabels läuft mit.
        svg.transition().duration(750).ease(d3.easeCubicInOut)
          .call(zoomBehavior.transform, t);
        document.getElementById('zoom-hint').classList.add('show');
        var hintLabel = document.getElementById('zoom-hint-label');
        hintLabel.hidden = false;
        hintLabel.textContent = DATA[key] ? DATA[key].country : '';
      }

      // Zurück zur Startansicht — auf dem Handy also in die herangezoomte Übersicht,
      // nicht in die leere Weltansicht. Ganz herauszoomen bleibt per Geste möglich.
      function zoomOut() {
        if (istStartansicht(d3.zoomTransform(svg.node()))) return;
        hideTip();
        svg.transition().duration(650).ease(d3.easeCubicInOut)
          .call(zoomBehavior.transform, startTransform);
        document.getElementById('zoom-hint').classList.remove('show');
        scheduleLabels();
      }

      // ISO → Polygone mit mittlerer Länge westlich dieses Werts weglassen, damit die
      // Karte auf das Kernland fokussiert. 250 Frankreich: Übersee-Départements
      // (Guyana/Antillen, mittel < -20°). 643 Russland: Tschukotka jenseits der
      // Datumsgrenze (ein Polygon mit mittel ~-107°, «westlich von Kanada»).
      var CLIP_WEST = { 250: -20, 643: 0 };
      function prepareFeature(f) {
        var minLon = CLIP_WEST[+f.id];
        if (minLon != null && f.geometry && f.geometry.type === 'MultiPolygon') {
          var filtered = f.geometry.coordinates.filter(function (poly) {
            var lons = poly[0].map(function (cc) { return cc[0]; });
            return lons.reduce(function (a, b) { return a + b; }, 0) / lons.length > minLon;
          });
          if (filtered.length !== f.geometry.coordinates.length) {
            return Object.assign({}, f, { geometry: { type: 'MultiPolygon', coordinates: filtered } });
          }
        }
        return f;
      }

      var zoomHint = document.getElementById('zoom-hint');
      if (zoomHint) zoomHint.addEventListener('click', zoomOut);

      // +/- Bedienung. Laeuft ueber zoomBehavior, damit scaleExtent, translateExtent
      // und die Label-Neuplatzierung von selbst greifen.
      var btnIn  = document.getElementById('map-zoom-in');
      var btnOut = document.getElementById('map-zoom-out');
      var ZOOM_STEP = 1.6;

      function zoomStep(faktor) {
        svg.transition().duration(220).ease(d3.easeCubicOut)
          .call(zoomBehavior.scaleBy, faktor);
      }
      function updateZoomButtons(k) {
        if (!btnIn || !btnOut) return;
        btnIn.disabled  = k >= 15.99;
        btnOut.disabled = k <= 1.001;
      }
      if (btnIn)  btnIn.addEventListener('click', function () { hideTip(); zoomStep(ZOOM_STEP); });
      if (btnOut) btnOut.addEventListener('click', function () { hideTip(); zoomStep(1 / ZOOM_STEP); });
      updateZoomButtons(1);

      // Ziehen darf kein Land auswählen: Position beim Drücken merken und den darauf
      // folgenden Klick verwerfen, wenn die Maus sich dabei bewegt hat (Zittern toleriert).
      var pressAt = null, wasDrag = false;
      svg.node().addEventListener('pointerdown', function (ev) {
        pressAt = [ev.clientX, ev.clientY];
        wasDrag = false;
      });
      svg.node().addEventListener('pointermove', function (ev) {
        if (!pressAt) return;
        var dx = ev.clientX - pressAt[0], dy = ev.clientY - pressAt[1];
        if (dx * dx + dy * dy > 16) wasDrag = true;   // > 4 px
      });
      svg.node().addEventListener('pointerup', function () { pressAt = null; });

      // Resize/Orientierungswechsel ändert die Kartenfläche, ohne ein zoom-Event zu feuern
      window.addEventListener('resize', scheduleLabels);

      if (IS_TOUCH) {
        var touchHintEl = document.getElementById('touch-hint');
        var touchHintTimer = null;
        var touchStart = null;
        wrap.addEventListener('touchstart', function (ev) {
          if (ev.touches.length >= 2) {
            touchHintEl.classList.remove('show');
            if (touchHintTimer) { clearTimeout(touchHintTimer); touchHintTimer = null; }
            touchStart = null;
          } else if (ev.touches.length === 1) {
            touchStart = [ev.touches[0].clientX, ev.touches[0].clientY];
          }
        }, { passive: true });
        wrap.addEventListener('touchmove', function (ev) {
          if (!touchStart || ev.touches.length !== 1) return;
          var dx = ev.touches[0].clientX - touchStart[0];
          var dy = ev.touches[0].clientY - touchStart[1];
          if (dx * dx + dy * dy < 100) return;
          touchHintEl.classList.add('show');
          if (touchHintTimer) clearTimeout(touchHintTimer);
          touchHintTimer = setTimeout(function () { touchHintEl.classList.remove('show'); }, 1500);
        }, { passive: true });
      }

      d3.json('https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json').then(function (world) {
        var features = topojson.feature(world, world.objects.countries).features;

        var prepared = features.map(prepareFeature);
        prepared.forEach(function (f) {
          var key = idToKey[+f.id];
          if (key) FEATURES[key] = f;        // für countryZoom
        });

        // Startansicht festlegen, bevor die Pins entstehen — sie lesen den Zoom aus.
        startTransform = berechneStartansicht();
        if (startTransform.k !== 1) svg.call(zoomBehavior.transform, startTransform);

        countriesG.selectAll('path')
          .data(prepared)
          .join('path')
          .attr('class', function (d) { return 'country' + (originIds.has(+d.id) ? ' origin' : ''); })
          .attr('d', pathGen)
          .on('mouseenter', function (ev, d) {
            var key = idToKey[+d.id];
            if (!key) return;
            var count = DATA[key].products.length;
            showTip(ev, DATA[key].country + ' <span class="map-tip__count">· ' + count + ' ' + produktLabel(DATA[key].products) + '</span>');
          })
          .on('mousemove', moveTip)
          .on('mouseleave', hideTip)
          .on('click', function (ev, d) {
            if (wasDrag) return;                 // die Karte wurde nur verschoben
            var key = idToKey[+d.id];
            if (!key) return;                    // Land ohne Öle: keine Aktion
            activate(key);                       // Panel sofort, Karte fährt parallel
            zoomToCountry(key);
          });

        Object.entries(DATA).forEach(function (entry, i) {
          var key = entry[0], d = entry[1];
          var pos = proj(d.coords);
          PIN_POS[key] = pos;

          var g = pinsG.append('g')
            .attr('class', 'pin-group')
            .attr('id', 'pin-' + key)
            .attr('transform', 'translate(' + pos[0] + ',' + pos[1] + ') scale(' + pinScale(d3.zoomTransform(svg.node()).k) + ')')
            .style('opacity', 0)
            .on('mouseenter', function (ev) {
              var count = d.products.length;
              showTip(ev, d.country + ' <span class="map-tip__count">· ' + count + ' ' + produktLabel(d.products) + '</span>');
            })
            .on('mousemove', moveTip)
            .on('mouseleave', hideTip)
            .on('click', function () {
              if (wasDrag) return;               // die Karte wurde nur verschoben
              activate(key);
              zoomToCountry(key);
            });

          if (IS_TOUCH) g.append('circle').attr('r', 10).attr('fill', 'transparent');
          var dotsG = IS_TOUCH ? g.append('g').attr('transform', 'scale(0.5)') : g;
          dotsG.append('circle').attr('class', 'pin-ring').attr('r', 5);
          dotsG.append('circle').attr('class', 'pin-bg').attr('r', 6);
          dotsG.append('circle').attr('class', 'pin-dot').attr('r', 2.5);
          g.append('text')
            .attr('class', 'pin-label')
            .attr('x', LABEL_GAP).attr('y', 0)
            .attr('text-anchor', 'start')
            .attr('dominant-baseline', 'middle')
            .attr('font-size', LABEL_REF_SIZE)
            .style('opacity', 0)          // placeLabels entscheidet über die Sichtbarkeit
            .text(d.country.split(' /')[0]);

          setTimeout(function () {
            g.transition().duration(500).style('opacity', 1)
              .on('end', function () { g.classed('alive', true); scheduleLabels(); });
          }, 300 + i * 70);
        });

        // Vorauswahl von der Produktseite: ?land=<ISO> (sections/produkt-herkunft.liquid),
        // gleicher Schlüssel wie DATA (String(p.iso)). Unbekanntes Land → Startansicht.
        var landParam = new URLSearchParams(location.search).get('land');
        if (landParam && DATA[landParam]) {
          activate(landParam, { ohneSprung: true });   // von der Produktseite: Seite bleibt oben
          zoomToCountry(landParam);
        }

        measureLabels();
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () { measureLabels(); scheduleLabels(); });
        }
        var totalDelay = 300 + Object.keys(DATA).length * 70 + 600;
        setTimeout(scheduleLabels, totalDelay);
      }).catch(function () {
        svg.append('text')
          .attr('x', W / 2).attr('y', H / 2)
          .attr('text-anchor', 'middle')
          .attr('fill', 'rgba(255,255,255,0.35)')
          .attr('font-family', 'Outfit, sans-serif')
          .attr('font-size', '13')
          .text('Karte benötigt eine Internetverbindung.');
      });

      function activate(key, optionen) {
        if (key === current) return;
        current = key;
        var d = DATA[key];
        countriesG.selectAll('.country').classed('active', false);
        d.ids.forEach(function (id) {
          countriesG.selectAll('.country').filter(function (f) { return +f.id === id; }).classed('active', true);
        });
        pinsG.selectAll('.pin-group').classed('active', false);
        d3.select('#pin-' + key).classed('active', true);
        scheduleLabels();     // aktives Land hat Vorrang und bekommt sein Label garantiert
        document.getElementById('i-region').textContent  = d.region;
        // Flagge vor den Ländernamen, sofern hinterlegt. Bewusst ohne innerHTML.
        var countryEl = document.getElementById('i-country');
        countryEl.textContent = '';
        if (d.flaggeUrl) {
          var fahne = document.createElement('img');
          fahne.src = d.flaggeUrl;
          fahne.alt = '';
          fahne.setAttribute('aria-hidden', 'true');
          fahne.addEventListener('error', function () { fahne.remove(); });
          countryEl.appendChild(fahne);
        }
        countryEl.appendChild(document.createTextNode(d.country));
        document.getElementById('i-desc').textContent    = d.desc;
        document.getElementById('i-num').textContent     = d.products.length;
        document.getElementById('i-label').textContent   = produktLabel(d.products);
        var list = document.getElementById('prod-list');
        list.innerHTML = '';
        d.products.slice().sort(function (a, b) { return a.name.localeCompare(b.name, 'de'); }).forEach(function (p) {
          var a = document.createElement('a');
          a.className = 'prod-row';
          a.href = p.url;
          // Bild bewusst mit leerem alt: der Name steht direkt daneben im selben Link.
          a.innerHTML =
            '<div class="p-bar" style="background:' + artFarbe(p.art) + '"></div>' +
            (p.bild ? '<img src="' + esc(p.bild) + '" alt="" width="44" height="44" loading="lazy" decoding="async">' : '') +
            '<div class="p-text">' +
              '<span class="p-name">' + esc(p.name) + '</span>' +
              (p.latin ? '<span class="p-latin">' + esc(p.latin) + '</span>' : '') +
            '</div>' +
            '<div class="p-meta">' +
              (p.tag ? '<span class="badge badge--sm">' + esc(p.tag) + '</span>' : '') +
            '</div>' +
            '<div class="p-arrow" aria-hidden="true">→</div>';
          list.appendChild(a);
        });
        var idle = document.getElementById('info-idle');
        var activeEl = document.getElementById('info-active');
        idle.classList.add('off');
        activeEl.classList.remove('on');
        void activeEl.offsetWidth;
        activeEl.classList.add('on');
        if (IS_TOUCH && !(optionen && optionen.ohneSprung)) zeigeRegion();
      }

      // Handy (Marc 2026-10-19): nach dem Antippen Region + Land direkt unter den
      // fixierten Kopf holen, aber nur, wenn die Zeile nicht schon sichtbar ist.
      // Früher scrollIntoView 'nearest': sprang je nach Lage und Länge der
      // Produktliste verschieden weit und ignorierte den Kopf.
      function zeigeRegion() {
        var kopf = document.getElementById('site-header');
        var kopfHoehe = kopf ? kopf.offsetHeight : 0;
        var oben = document.getElementById('info-panel').getBoundingClientRect().top;
        var zeile = document.getElementById('i-country').getBoundingClientRect().bottom;
        if (oben >= kopfHoehe && zeile <= window.innerHeight) return;
        var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: window.scrollY + oben - kopfHoehe - 8, behavior: ruhig ? 'auto' : 'smooth' });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
